import { DatasetEventsTable } from "./DatasetEventsTable";

interface DatasetEventsProps {
  datasetId: string;
}

export function DatasetEvents({ datasetId }: DatasetEventsProps) {
  return <DatasetEventsTable datasetId={datasetId} />;
}
